import React, { useState, useRef, useEffect, useMemo } from 'react'
import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
// import 'survey-core/defaultV2.min.css'

import { useConvertSurvey } from '../hooks/useConvertSurvey'
import { useSubmitAnswers } from '../hooks/useSubmitAnswers'
import 'survey-core/i18n/traditional-chinese'
import { useLoadProgress } from '../hooks/useLoadProgress'

const Agree = ({
  setAc,
  setTk,
  ac,
  tk,
  pid,
  setIsLoading,
  setCompletionMessage,
  serial_num,
  // 暫存需加
  userId,
}) => {
  const [myAgreeJson, setMyAgreeJson] = useState(null)
  const choicesOrderRef = useRef({})
  const choiceIndexMapRef = useRef({})
  const bringOptionsMapRef = useRef({})
  // const progressLoadedRef = useRef(false)
  // 暫存需加
  const [isReady, setIsReady] = useState(false)

  // 暫存需加
  const userIdRef = useRef(null)
  useEffect(() => {
    if (userId) userIdRef.current = userId
  }, [userId])

  // 需要登入嗎
  const requiresLogin = {
    login: userId ? true : false,
    title: '驗證碼',
    placeholder: '請輸入驗證碼',
    alert: '請檢查網址是否有誤，或聯絡 EZC 小編',
  }
  const [imagesReadingTime, setImagesReadingTime] = useState(0)
  // 圖片閱讀時間(秒)
  // useEffect(() => {
  //   setImagesReadingTime(3)
  // }, [])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const agreeSurvey = new Model(myAgreeJson)

  // 問卷編號
  // const pid = pid
  // 跳題 小心複選題要用陣列

  const visibleIfConditionsInit = {
    q1: '{q0} = 0 ',
    q2: '{q0} = 0 ',
    // q7: '{q6} = ["none"]',
    // q36: `{q35} <> ['none']`,
  }

  // const visibleIfConditionsInit = {

  // }
  // const visibleIfConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  // 非必填(從 0 計算)
  // const notRequired = [100]
  const notRequired = null

  const mappedRateChoice = null
  // const pageBreakQuestions = ['q6', 'q11', 'q15']
  const pageBreakQuestions = null

  // const triggersConditionsInit = [
  //   {
  //     type: 'complete',
  //     expression:
  //       '({q0} = 1 or {q0} = 2) or ({q1} = 0 or {q1} = 1 or {q1} = 8 or {q1} = 9) or ({q2} = 1 or {q2} = 2) or ({q5} = 0 or {q5} = 1 or {q5} = 2 or {q5} = 3)',
  //     //     expression: `{q3} <> 4 or ({q4} = 16 or {q4} = 20 or {q4} = 21)`,
  //   },
  //   {
  //     type: 'complete',
  //     expression: '{q6} notcontains 0',
  //   },
  // ]
  const triggersConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  const convertedSurvey = useConvertSurvey({
    survey: agreeSurvey,
    pid,
    setAc,
    setTk,
    ac,
    tk,
    setMyAgreeJson,
    imagesReadingTime,
    setImagesReadingTime,
    setIsLoading,
    // completedHtml,
    visibleIfConditionsInit,
    notRequired,
    mappedRateChoice,
    pageBreakQuestions,
    requiresLogin,
    triggersConditionsInit,
    serial_num,
    bringOptionsMapRef,
    // 暫存需加
    userIdRef,
  })

  // const newSurvey = new Model(convertedSurvey)

  const surveyModel = useMemo(() => {
    if (!convertedSurvey) return null
    return new Model(convertedSurvey)
  }, [convertedSurvey])

  const otherAnswersRef = useRef({})
  const noneAnswersRef = useRef({})
  const matrixAnswersRef = useRef({})
  const timestampsRef = useRef({})

  useLoadProgress({
    surveyModel: surveyModel, // 若 myAgreeJson 為 null，agreeSurvey 亦為 null
    convertedSurvey: myAgreeJson,
    isReady,
    requiresLogin,
    setIsLoading,
    pid,
    ac,
    tk,
    choiceIndexMapRef,
    choicesOrderRef,
    bringOptionsMapRef,
    otherAnswers: otherAnswersRef.current,
    noneAnswers: noneAnswersRef.current,
    matrixAnswers: matrixAnswersRef.current,
    timestamps: timestampsRef.current,
  })

  // const { loadSavedAnswers, setStartingPage } = useLoadProgress({
  //   pid,
  //   ac,
  //   tk,
  //   choiceIndexMapRef,
  //   choicesOrderRef,
  //   bringOptionsMapRef,
  //   otherAnswers: {},
  //   noneAnswers: {},
  //   matrixAnswers: {},
  //   timestamps: {},

  //    surveyModel,
  // convertedSurvey,
  // isReady,
  // })

  // 載入儲存進度：在 surveyModel 建立後載入進度
  // useEffect(() => {
  //   const loadProgressForSurveyModel = async () => {
  //     // 避免重複載入
  //     if (progressLoadedRef.current) return

  //     // 確保必要的條件都滿足
  //     if (
  //       !surveyModel ||
  //       !convertedSurvey ||
  //       !ac ||
  //       !tk ||
  //       !requiresLogin?.login ||
  //       !isReady
  //     ) {
  //       return
  //     }

  //     try {
  //       progressLoadedRef.current = true
  //       setIsLoading(true)

  //       console.log('開始為 surveyModel 載入進度...')

  //       // 先硬編碼測試 setValue 是否生效
  //       // console.log('測試硬編碼設定 q0 = 1')
  //       // surveyModel.setValue('q0', 1)
  //       // console.log('設定後的值:', surveyModel.getValue('q0'))
  //       // console.log('所有資料:', surveyModel.data)

  //       // 載入後端的答案資料
  //       const savedAnswers = await loadSavedAnswers(pid)

  //       if (savedAnswers && savedAnswers.length > 0) {
  //         console.log('找到儲存的答案:', savedAnswers)

  //         // 簡化的轉換邏輯（暫時不依賴 receivedSurvey）
  //         const surveyData = {}
  //         const commentData = {}

  //         savedAnswers.forEach((answerItem) => {
  //           const questionName = `q${answerItem.qi}`

  //           // 先檢查這個問題在 surveyModel 中的類型
  //           const question = surveyModel.getQuestionByName(questionName)
  //           if (!question) {
  //             console.warn(`找不到問題 ${questionName}`)
  //             return
  //           }

  //           console.log(
  //             `處理問題 ${questionName}, 類型: ${question.getType()}, 答案:`,
  //             answerItem.ans
  //           )

  //           // 根據問題類型處理答案
  //           if (question.getType() === 'matrix') {
  //             // 矩陣題特殊處理
  //             if (answerItem.ans && answerItem.ans.length > 0) {
  //               const matrixValue = {}

  //               // 獲取矩陣的行（rows）
  //               const rows = question.rows

  //               answerItem.ans.forEach((answerArray, rowIndex) => {
  //                 if (rows[rowIndex]) {
  //                   // 使用 row 的 value 作為 key，而不是 text
  //                   const rowKey = rows[rowIndex].value

  //                   if (Array.isArray(answerArray) && answerArray.length > 0) {
  //                     matrixValue[rowKey] = answerArray[0]
  //                   } else if (typeof answerArray === 'number') {
  //                     matrixValue[rowKey] = answerArray
  //                   }
  //                 }
  //               })

  //               console.log(`矩陣題 ${questionName} 轉換結果:`, matrixValue)
  //               console.log(`矩陣題 ${questionName} 的行定義:`, rows)
  //               surveyData[questionName] = matrixValue
  //             }
  //           } else {
  //             // 其他題型的處理
  //             if (answerItem.ans && answerItem.ans.length > 0) {
  //               let answerValue

  //               // 檢查是否有 other 答案
  //               const hasOther =
  //                 answerItem.other && Object.keys(answerItem.other).length > 0

  //               if (hasOther) {
  //                 // 半開放題：需要特殊處理 other 選項
  //                 console.log(
  //                   `處理半開放題 ${questionName}, other:`,
  //                   answerItem.other
  //                 )

  //                 // 將答案中的 other 索引轉換為 'other'
  //                 const otherIndex = parseInt(Object.keys(answerItem.other)[0])
  //                 const otherText = Object.values(answerItem.other)[0]

  //                 if (answerItem.ans.length === 1) {
  //                   // 單選題
  //                   answerValue =
  //                     answerItem.ans[0] === otherIndex
  //                       ? 'other'
  //                       : answerItem.ans[0]
  //                 } else {
  //                   // 多選題
  //                   answerValue = answerItem.ans.map((ans) =>
  //                     ans === otherIndex ? 'other' : ans
  //                   )
  //                 }

  //                 // 先設定主答案
  //                 surveyData[questionName] = answerValue
  //                 // 將評論答案分開處理
  //                 commentData[`${questionName}`] = otherText
  //               } else {
  //                 // 沒有 other 的一般題型
  //                 if (answerItem.ans.length === 1) {
  //                   answerValue = answerItem.ans[0]
  //                 } else {
  //                   answerValue = answerItem.ans
  //                 }
  //                 surveyData[questionName] = answerValue
  //               }
  //             }
  //           }

  //           // 處理 other 答案
  //           // if (answerItem.other && Object.keys(answerItem.other).length > 0) {
  //           //   Object.entries(answerItem.other).forEach(
  //           //     ([otherIndex, otherText]) => {
  //           //       surveyData[`${questionName}-Comment`] = otherText
  //           //     }
  //           //   )
  //           // }
  //         })

  //         console.log('轉換後的主答案:', surveyData)
  //         console.log('轉換後的評論答案:', commentData)

  //         // 暫時禁用事件以避免錯誤
  //         // const originalValueChangedCallbacks =
  //         //   surveyModel.onValueChanged.callbacks.slice()
  //         // surveyModel.onValueChanged.clear()

  //         // 第一階段：設定主答案
  //         Object.entries(surveyData).forEach(([questionName, answer]) => {
  //           try {
  //             surveyModel.setValue(questionName, answer)
  //             console.log(`✅ 成功設定主答案 ${questionName}:`, answer)
  //           } catch (error) {
  //             console.error(`❌ 設定主答案 ${questionName} 失敗:`, error)
  //           }
  //         })

  //         // 設置起始頁面
  //         const startPageSet = setStartingPage(surveyModel, savedAnswers)
  //         if (startPageSet) {
  //           console.log('已設置問卷從進度頁面開始')
  //         }

  //         // 第二階段：延遲設定 Comment 答案（確保主答案已經生效）
  //         if (Object.keys(commentData).length > 0) {
  //           console.log('⏳ 準備設定評論答案...')

  //           // 使用更長的延遲，確保主答案已完全生效並觸發了相關的事件
  //           setTimeout(() => {
  //             Object.entries(commentData).forEach(
  //               ([commentKey, commentValue]) => {
  //                 try {
  //                   // 檢查對應的主問題是否存在且有 other 選項
  //                   const mainQuestionName = commentKey.replace('-Comment', '')
  //                   const mainQuestion =
  //                     surveyModel.getQuestionByName(mainQuestionName)

  //                   if (mainQuestion && mainQuestion.showOtherItem) {
  //                     // 檢查主問題的當前值是否包含 'other'
  //                     const currentValue =
  //                       surveyModel.getValue(mainQuestionName)
  //                     const hasOtherValue = Array.isArray(currentValue)
  //                       ? currentValue.includes('other')
  //                       : currentValue === 'other'

  //                     if (hasOtherValue) {
  //                       // 暫時移除 valueChanged 事件監聽器來避免錯誤
  //                       // const originalValueChanged =
  //                       //   surveyModel.onValueChanged.callbacks.slice()
  //                       // surveyModel.onValueChanged.clear()

  //                       // surveyModel.setValue(commentKey, commentValue)
  //                       // surveyModel.setValue(commentKey, 'other')
  //                       surveyModel.setComment(commentKey, commentValue)
  //                       console.log(
  //                         `✅ 成功使用 setComment 設定評論 ${commentKey}:`,
  //                         commentValue
  //                       )
  //                       // 驗證設定是否成功
  //                       const setComment = surveyModel.getComment(commentKey)
  //                       console.log(
  //                         `🔍 驗證評論設定結果 ${commentKey}:`,
  //                         setComment
  //                       )

  //                       // 恢復事件監聽器
  //                       // originalValueChanged.forEach((callback) => {
  //                       //   surveyModel.onValueChanged.add(
  //                       //     callback.func,
  //                       //     callback.context
  //                       //   )
  //                       // })
  //                     } else {
  //                       console.log(
  //                         `⚠️ 主問題 ${mainQuestionName} 當前值不包含 other，跳過評論設定`
  //                       )
  //                     }
  //                   } else {
  //                     console.log(
  //                       `⚠️ 主問題 ${mainQuestionName} 不存在或無 other 選項`
  //                     )
  //                   }
  //                 } catch (error) {
  //                   console.error(`❌ 設定評論 ${commentKey} 失敗:`, error)
  //                 }
  //               }
  //             )
  //             // 恢復事件處理器
  //             // originalValueChangedCallbacks.forEach((callback) => {
  //             //   surveyModel.onValueChanged.add(callback)
  //             // })
  //           }, 500) // 增加延遲時間到 500ms
  //         } else {
  //           console.log('ℹ️ 沒有評論答案需要設定')
  //           // 沒有評論答案時立即恢復事件處理器
  //           // originalValueChangedCallbacks.forEach((callback) => {
  //           //   surveyModel.onValueChanged.add(callback)
  //           // })
  //         }

  //         // Object.entries(commentData).forEach(([commentKey, commentValue]) => {
  //         //   try {
  //         //     const mainQuestionName = commentKey.replace('-Comment', '')
  //         //     const mainQuestion =
  //         //       surveyModel.getQuestionByName(mainQuestionName)

  //         //     if (mainQuestion && mainQuestion.showOtherItem) {
  //         //       const currentValue = surveyModel.getValue(mainQuestionName)
  //         //       const hasOtherValue = Array.isArray(currentValue)
  //         //         ? currentValue.includes('other')
  //         //         : currentValue === 'other'

  //         //       if (hasOtherValue) {
  //         //         surveyModel.setValue(commentKey, commentValue)
  //         //         console.log(`✅ 成功設定評論 ${commentKey}:`, commentValue)
  //         //       }
  //         //     }
  //         //   } catch (error) {
  //         //     console.error(`❌ 設定評論 ${commentKey} 失敗:`, error)
  //         //   }
  //         // })

  //         // 強制更新所有問題的UI
  //         setTimeout(() => {
  //           try {
  //             surveyModel.getAllQuestions().forEach((question) => {
  //               if (question.value !== undefined) {
  //                 question.value = question.value
  //               }
  //             })

  //             if (surveyModel.render) {
  //               surveyModel.render()
  //             }

  //             const currentPageNo = surveyModel.currentPageNo
  //             surveyModel.currentPageNo = currentPageNo

  //             console.log('強制UI更新完成')
  //           } catch (error) {
  //             console.error('強制UI更新失敗:', error)
  //           }
  //         }, 200)

  //         // 恢復事件處理（在UI更新後）
  //         setTimeout(() => {
  //           // 重新添加事件監聽器（這些會在 useSubmitAnswers 中重新設置）
  //           console.log('準備恢復事件監聽器...')

  //           // 檢查設定結果
  //           console.log('載入完成後的問卷資料:', surveyModel.data)
  //           console.log('進度載入完成！')
  //         }, 200)

  //         // 檢查設定結果
  //         setTimeout(() => {
  //           console.log('載入完成後的問卷資料:', surveyModel.data)
  //           console.log('進度載入完成！')
  //         }, 600)
  //       } else {
  //         console.log('沒有找到儲存的進度')
  //       }
  //     } catch (error) {
  //       console.error('載入進度失敗:', error)
  //       progressLoadedRef.current = false // 失敗時重置，允許重試
  //     } finally {
  //       setIsLoading(false)
  //     }
  //   }

  //   // 延遲執行，確保 surveyModel 完全初始化
  //   if (surveyModel && isReady) {
  //     setTimeout(() => {
  //       loadProgressForSurveyModel()
  //     }, 100)
  //   }
  // }, [
  //   surveyModel,
  //   convertedSurvey,
  //   ac,
  //   tk,
  //   loadSavedAnswers,
  //   setStartingPage,
  //   pid,
  //   requiresLogin?.login,
  //   setIsLoading,
  //   isReady,
  // ])

  useEffect(() => {
    console.log('bringOptionsMapRef', bringOptionsMapRef)
  }, [bringOptionsMapRef])

  // SurveyModel 初始化完成 → 標記可互動
  useEffect(() => {
    if (agreeSurvey) {
      const id = setTimeout(() => setIsReady(true), 50)
      return () => clearTimeout(id)
    }
  }, [agreeSurvey])
  // useEffect(() => {
  //   console.log('bringOptionsMapRef', bringOptionsMapRef)
  // }, [bringOptionsMapRef])

  // // 帶入選項
  // const questionMappings = {
  //   q2: 'q3',
  // }

  // 設置 survey 準備就緒狀態
  useEffect(() => {
    if (surveyModel) {
      // 給 survey 一些時間完成初始化
      setTimeout(() => {
        setIsReady(true)
      }, 50)
    }
  }, [surveyModel])

  function helpFunction(survey, options) {}

  const canShowPrevButtonPages = null

  useSubmitAnswers({
    survey: surveyModel,
    pid,
    ac,
    tk,
    imagesReadingTime,
    setIsLoading,
    helpFunction,
    canShowPrevButtonPages,
    choicesOrderRef,
    choiceIndexMapRef,
    bringOptionsMapRef,
    // endSurveyMsg,
    // 暫存需加
    requiresLogin,
    userIdRef, // 傳入 ref 而不是直接傳 userId
    enableProgressSaving: requiresLogin.login, // 根據登入需求啟用
  })

  return (
    <>
      {surveyModel ? (
        <Survey model={surveyModel} key={pid} />
      ) : myAgreeJson ? (
        <Survey model={agreeSurvey} />
      ) : (
        <></>
      )}
    </>
  )
}

export default Agree
